import { OverlayRef } from '@angular/cdk/overlay';
import { TemplateRef, Type } from '@angular/core';
import { Subject } from 'rxjs';

export interface OverlayCloseEvent<R> {
    type: 'backdropClick' | 'close';
    data: R;
}

// R = Response Data Type, T = Data passed to Modal Type
export class VDialogRef<R = any, T = any> {
    afterClosed$ = new Subject<OverlayCloseEvent<R>>();
    outputs: { [outputName: string]: (value: any) => void } = {};

    constructor(
        public overlay: OverlayRef,
        public content: string | TemplateRef<any> | Type<any>,
        public data: T // pass data to modal i.e. FormData
    ) {
        overlay.backdropClick().subscribe(() => this._close('backdropClick', null));
    }

    setOutputs(outputs: { [outputName: string]: (value: any) => void }): void {
        // Store outputs to be bound later
        this.outputs = outputs;
    }

    close(data?: R): void {
        this._close('close', data);
    }

    // --

    private _close(type: 'backdropClick' | 'close', data: R): void {

        this.overlay.addPanelClass('dialog-closing');
        if (this.overlay.backdropElement?.classList) {
            this.overlay.backdropElement.classList.add('dialog-closing');
        }

        this.afterClosed$.next({
            type,
            data
        });

        this.afterClosed$.complete();

        setTimeout(() => { this.overlay.dispose(); }, 300);
    }
}
